import { getCurrencySymbol } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import currencyCodes from 'currency-codes';
import { useMemo } from 'react';

import i18n from '@app/core/locale/i18n';
import { Logger } from '@app/core/logger/logger';

export const useCurrencyLabel = (currency: string): string => {
  return useMemo(() => {
    const currencyRecord = currencyCodes.code(currency);
    if (!currencyRecord) {
      Logger.warn('Currency code not found for currency', { currency });
      return currency;
    }
    return getCurrencySymbol(i18n.language, currencyRecord);
  }, [currency]);
};
